var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-bar f-a"},_vm._l((_vm.header),function(item,index){return _c('div',{staticClass:"item flex1 f-a-j pointer",class:{active:_vm.tabs_index==index},on:{"click":function($event){return _vm.to(item)}}},[_c('div',[_vm._v(_vm._s(_vm.$store.state.language=='cn'?item.title:item.title_en))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }